import { type FC } from 'react';

// styles
import dibsCss from 'dibs-css';
import classnames from 'classnames';
import styles from './SbRespFeaturedTrending.scss';

const TILE_COUNT = 3;

export const SbRespFeaturedTrendingLoading: FC = () => (
    <div
        className={classnames(
            dibsCss.wFull,
            dibsCss.flex,
            dibsCss.flexCol,
            dibsCss.justifyCenter,
            dibsCss.itemsCenter
        )}
    >
        <span
            className={classnames(
                dibsCss.mbMedium,
                styles.titlePlaceholder,
                styles.loadingAnimation
            )}
        />
        <div
            className={classnames(
                dibsCss.wFull,
                dibsCss.flex,
                dibsCss.justifyBetween,
                dibsCss.textCenter
            )}
        >
            {[...Array(TILE_COUNT)].map((_, index) => (
                <div
                    key={index}
                    className={classnames(styles.tile, styles.loadingAnimation, dibsCss.wFull)}
                />
            ))}
        </div>
    </div>
);
